import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  
} from "react-bootstrap";
import Datetime from "react-datetime";
import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { updateSubscription_old_data,updateSubscription, EditSubscriptionPackage,searchMedicationForSubProduct, GetSubscriptionPackageByID } from '../../../Listfunction';
import NotificationSystem from 'react-notification-system';
import {style} from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class editsubscriptionpackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title : '',
      titleError : null,
      description : '',
      descriptionError:null,
      brand : '',
      brandError : null,
      size : '',
      sizeError : null,
      _notificationSystem: null,
      cardHidden: true,
      medication : '',
      medicationItems : []

    }
    this.onChange = this.onChange.bind(this);
    this.onSubmit =  this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);

  }
  handleSuccess(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'success';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>Subscription Package</b> - Updated Successfully .
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push('/admin/subscriptionpackage');
    }, 3000);
  }
  handleClick(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'error';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>something went wrong</b>.
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }

  componentDidMount(){
    var token = JSON.parse(localStorage.getItem('user'));
    const  obj = token.token;
    var id = JSON.parse(localStorage.getItem('subscriptionpackageID'));

    this.setState({_notificationSystem: this.refs.notificationSystem})
    setTimeout(
      function() {
        this.setState({ cardHidden: false }); 
      }.bind(this),
      700
    );

    GetSubscriptionPackageByID(id,obj)
    .then((res)=>{
        var medicationItems =[] 
        var data = res.data.data;
        medicationItems.push({ value:data.medication_id , label: data.medication_title })
        
        console.log(data);
        this.setState({
            title: data.title,
            description : data.description,
            brand : data.brand ,
            size : data.size,
            medication : data.medication_id,
            medicationItems : medicationItems
        })
        
    })
  }
  onChange = ((event) =>{
    const target = event.target;
      const value =  target.value;
      const name = target.name;
  
      this.setState({
        [name]: value
      });
   })
   onSubmit = () =>{
    let error =  false ;
    if(this.state.title.length == 0)
      {error = true
         this.setState({
          titleError: (
              <small className="text-danger">
                 Title is required..
              </small>
            )
          })
        }else{ this.setState({ titleError: null });}
        if(this.state.size.length == 0)
      {error = true
         this.setState({
          sizeError: (
              <small className="text-danger">
                 size is required..
              </small>
            )
          })
        }else{ this.setState({ sizeError: null });}
      //   if(this.state.description.length == 0)
      // {error = true
      //    this.setState({
      //     descriptionError: (
      //         <small className="text-danger">
      //            Description is required..
      //         </small>
      //       )
      //     })
      //   }else{ this.setState({ descriptionError: null });}
        if(this.state.brand.length == 0)
      {error = true
         this.setState({
          brandError: (
              <small className="text-danger">
                  Brand is required..
              </small>
            )
          })
        }else{ this.setState({ brandError: null });}

       if(!error)
       {
    var token = JSON.parse(localStorage.getItem('user'));
    const  obj = token.token;
    var id = JSON.parse(localStorage.getItem('subscriptionpackageID'));
    EditSubscriptionPackage(
      this.state.title,
      this.state.description,
      this.state.brand,
      this.state.size,
      this.state.medication,
      id,obj)
    .then((res)=>{
      if(res.data.success === false)
      {
      this.handleClick('bl')
      }
      else if(res.data.success === true)
      {
        this.handleSuccess('bl')
        
      
      }
    })
    .catch((error) => {
      this.handleNetworkError('bl', error)
      console.log(error,"== error");
   });
  }
   }
   handleNetworkError(position, error) {
     var color = Math.floor((Math.random() * 4) + 1);
     var level;
     switch (color) {
         case 1:
         level = 'success';
         break;
         case 2:
         level = 'warning';
         break;
         case 3:
         level = 'error';
         break;
         case 4:
         level = 'info';
         break;
         default:
         break;
     }
     level = 'error';
     this.state._notificationSystem.addNotification({
         title: (<span data-notify="icon" className="pe-7s-gift"></span>),
         message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
         level: level,
         position: position,
         autoDismiss: 15,
     });
   }
     
   inputOnChange = (event,i) => {
    const self = this;
  
    if (self.state.typingTimeout) {
       clearTimeout(self.state.typingTimeout);
    }
  
    self.setState({
       name: event.target.value.trim(),
       typing: false,
       typingTimeout: setTimeout(function () {
           self.sendToParent(self.state.name.trim());
         }, 500)
    });
  }
  sendToParent = async(name) => {
    //this.props.searching(this.state.name);c
  
   if(this.state.name.length !== 0){
  
        let compelte =1   
          let pg_no = 1
          var token = JSON.parse(localStorage.getItem('user'));
  
          const  obj = token.token;
          
    await  searchMedicationForSubProduct(this.state.name,obj)
          .then(res=> {
            
            var mdata = res.data.data
            
            var medicationItems = []
           
              //alert("in else")
              this.setState({ medication_detail : []  }); 
              
              res.data.data.map((x, i) => {
                medicationItems.push({ value:x.id , label: x.title + '('+x.item_code+')' })
              })
              
              
              
              this.setState({ 
                medicationItems : medicationItems,  });
       
          
          
        })
      }
      else{
          this.setState({  medication_detail : [],
          medicationItems : [],  });
      }
  }
  handleSelectChange = ( value) => {

    this.setState({
      medication: value.value
    });
  };
  render() {
    return (
      <div className="main-content">
        <Grid fluid>
        <NotificationSystem ref="notificationSystem" style={style}/>

          <Row>
            <Col md={12}>
              <Card
                
                content={
                  <form >
                    <Row>
                      <Col md={6}>
                      <FormGroup>
                      <ControlLabel>Medicine</ControlLabel>
                      <div onKeyUp={e =>this.inputOnChange(e)} className="Appy">
                                  <Select
                                        className="react-select primary"
                                        classNamePrefix="react-select"
                                        name="description"
                                        value={this.state.medicationItems.filter(option => option.value === this.state.medication)}
                                        onChange={value => this.handleSelectChange( value)} 
                                        options={this.state.medicationItems}
                                        placeholder="Medication"
                                        noOptionsMessage={() => "Type Item Name or Code"}
                                      />  
                                      </div>
                      {this.state.titleError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Title</ControlLabel>
                      <FormControl name="title" value={this.state.title} onChange={event => {
                        this.setState({ title: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                            titleError: (
                                <small className="text-danger">
                                  title is required.
                                </small>
                              )
                            })
                          : this.setState({ titleError: null });
                      }} placeholder="Enter title" type="text" />
                      {this.state.titleError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel> Description</ControlLabel>
                      <textarea name="description" rows="5" className="form-control" value={this.state.description} onChange={event => {
                        this.setState({ description: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                            descriptionError: (
                                <small className="text-danger">
                                  Description is required.
                                </small>
                              )
                            })
                          : this.setState({ descriptionError: null });
                      }} placeholder="Enter Description" type="text" ></textarea>
                      {this.state.descriptionError}
                    </FormGroup>
                    </Col>
                    <Col md={6}>
                    <FormGroup>
                      <ControlLabel>Brand</ControlLabel>
                      <FormControl name="brand" value={this.state.brand} onChange={event => {
                        this.setState({ brand: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                            brandError: (
                                <small className="text-danger">
                                  brand is required.
                                </small>
                              )
                            })
                          : this.setState({ brandError: null });
                      }} placeholder="Enter brand" type="text" />
                      {this.state.brandError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Size</ControlLabel>
                      <FormControl name="size" value={this.state.size} onChange={event => {
                        this.setState({ size: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                            sizeError: (
                                <small className="text-danger">
                                  size is required.
                                </small>
                              )
                            })
                          : this.setState({ sizeError: null });
                      }} placeholder="Enter size" type="text" />
                      {this.state.sizeError}
                    </FormGroup>
                    </Col>
                    
                    </Row>

                    <Button onClick={this.onSubmit.bind(this)} class="btn-color"  fill>
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
            
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editsubscriptionpackage;
